// components/UpgradeModal.js
import React from "react";
import { useNavigate } from "react-router-dom";
const UpgradeModal = ({ show, onClose, onUpgrade }) => {
    if (!show) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Upgrade Required</h2>
          <p className="text-gray-600 mb-6">
            This feature is only available for subscribed users. Upgrade your plan to unlock full access.
          </p>
          <div className="flex justify-end gap-4">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-[#3913C5] text-white rounded hover:bg-[#2a0d8f]"
              onClick={() => {
                onClose();
                onUpgrade();
              }}
            >
              Upgrade Plan
            </button>
          </div>
        </div>
      </div>
    );
  };
  

export default UpgradeModal;
